import * as userActions from './actions';

import { UserState } from './types';
import { combineReducers } from 'redux';
import { createReducer } from 'typesafe-actions';
import { isServerUnreachable } from './network-failure';

export const initialState: UserState = {
  user: null,
  loading: false,
  error: null,
};

const loading = createReducer(initialState.loading)
  .handleAction(userActions.getCurrentUser.request, () => true)
  .handleAction(userActions.getCurrentUser.success, () => false)
  .handleAction(userActions.getCurrentUser.failure, () => false);

const user = createReducer(initialState.user)
  .handleAction(userActions.getCurrentUser.success, (_state, action) => action.payload.user)
  // Kept when the server was unreachable: a mid-session blip must not sign the tenant out of a live flow.
  .handleAction(userActions.getCurrentUser.failure, (state, action) =>
    isServerUnreachable(action.payload.error) ? state : null,
  );

const error = createReducer(initialState.error)
  .handleAction(userActions.getCurrentUser.request, () => null)
  .handleAction(userActions.getCurrentUser.success, () => null)
  .handleAction(userActions.getCurrentUser.failure, (_state, action) => action.payload.error);

export default combineReducers({
  loading,
  user,
  error,
});
